import { render } from "./Principal.vue?vue&type=template&id=f1c1d8b6"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
script.render = render

export default script